module.exports = __webpack_public_path__ + "static/media/close-nav-icon-midnight.b3d869aa.svg";